module.exports = __webpack_public_path__ + "static/img/teofilo-san-luis-jr.d9e743e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/teofilo-san-luis-jr.jpg
// module id = 377
// module chunks = 1